const Jtgk = () => {
  return {
    name: 'jtgk',
    data: {
      title: '浙建集团官网 - 移动端',
      description: '欢迎访问浙建集团官方网站移动版',
    },
  };
};

export default Jtgk;
